import { ProductIdentifierModel } from '../types/DomainTldsPrices'
import { BUSINESS_CARD_MPV_ID } from './app'

export const LOGOS_SERVICE_BASE = 'https://logos-service.algo.design.vpsvc.com'
export const GENAI_LOGOMAKER_BACKEND_BASE = 'https://logomaker-backend.prod.logomaker.vpsvc.com'
export const LOGOS_V2_URL = `${LOGOS_SERVICE_BASE}/v2/logos`
export const LOGOMATION_BASE = 'https://stage-logomation-service.algo.design.vpsvc.com'
export const RICH_CUSTOMER_PROFILE_URL = 'https://rich.customer-profile.vpsvc.com/api/v2/customer/me/brand'

export const VISTA_WIX_BASE_URL = 'https://partners.vpsvc.com'
export const URL_SERVICE_BASE_URL = 'https://url.prod.merch.vpsvc.com'

export const LOGO2LIFE_BACKEND_BASE_URL = 'https://prod-backend.logo2life.vpsvc.com'
export const LOGO_VARIANT_BASE_URL = 'https://logo-variant.algo.design.vpsvc.com'

export const DESIGN_ENGINE_API_BASE_URL = 'https://design-engine.vpsvc.com/'

export const getDesignSpecificationForProductUrl = (prd: string, productVersion: number, optionsQueryString: string, culture: string) => {
  return `https://design-specifications.design.vpsvc.com/v2/designViews/products/${prd}/${productVersion}?${optionsQueryString}culture=${culture}&requester=logo2life`
}

export const DomainSuggestionsApiLoggedInUser = (partnerName: string, canonicalId: string, locale: string) =>
  `${VISTA_WIX_BASE_URL}/api/v1/domain/search/${partnerName}/${canonicalId}?locale=${locale}&source=logomaker-domains&requestor=logo2life`

export const getDomainTldPrice = (market: string, productIdentifier: ProductIdentifierModel) => {
  const { productKey, productVersion } = productIdentifier
  const SELECTIONS = productIdentifier.productAttributes
    .map(({ key, value }) => {
      const encodedKey = encodeURIComponent(key)
      const encodedValue = encodeURIComponent(value)
      return `Selections[${encodedKey}]=${encodedValue}`
    })
    .join('&')
  return `https://website-pricing-service-cdn.prices.cimpress.io/v4/prices/estimated?merchantId=VISTAPRINT&market=${market}&requestor=logo2life&quantities=1&productKey=${productKey}&productVersion=${productVersion}&${SELECTIONS}`
}

export const UrlServiceApiForExploreMoreDomainsBtn = (locale: string) =>
  `${URL_SERVICE_BASE_URL}/v3/url/vistaprint/${locale}/digital-merchandising:domains-wix-search-and-suggestions?requestor=logo2life`

export const GET_BUSINESS_CARD_PRICE = (locale: string, country: string) => {
  return `https://vpmerchant.dsp.dst.vpsvc.com/v1/Callout/${locale}?mpvId=${BUSINESS_CARD_MPV_ID}`
}
export const WIX_ACCOUNT_INFO_URL = (canonicalId: string) => {
  return `https://partners.vpsvc.com/api/v1/account/WIX/${canonicalId}`
}
export const LOGO_PREVIEW_URL = (
  imageType: string,
  backgroundMode: string,
  width: number,
  height?: number,
  logoVariation?: string | undefined,
) => {
  let url: string = `${LOGOMATION_BASE}/v1/download/getLogoForPreview?type=${imageType}&width=${width}&backgroundMode=${backgroundMode}`
  if (logoVariation) {
    url += `&logoVariation=${logoVariation}`
  }
  if (height) {
    url += `&height=${height}`
  }
  return url
}

export const LOGO_DOWNLOAD_API_URL = (logoId: string, downloadFormat: string) => {
  return `${LOGOS_SERVICE_BASE}/v1/logos/${logoId}/download?downloadFormat=${downloadFormat}`
}

export const GENAI_LOGO_DOWNLOAD_API_URL = (logoId: string) => {
  return `${GENAI_LOGOMAKER_BACKEND_BASE}/v1/genai-logos/download?logoId=${logoId}`
}

export const SHEREBERT_UPLOAD_URL_V3 = 'https://api.sherbert.cimpress.io/v3/assets'

export const SHEREBERT_UPLOAD_URL_V2 = 'https://api.sherbert.cimpress.io/v2/assets'

export const DIGITAL_PERSONALIZATION_SERVIE_URL =
  process.env.UBIK_ENV === 'prod' || !process.env.UBIK_ENV
    ? 'https://prod.personalization-service-api.digital.vistaprint.io'
    : 'https://qa.personalization-service-api.digital.vistaprint.io'
